import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAccountBalance,
  MdArrowBackIos,
  MdAutoAwesome,
  MdCalendarToday,
  MdCampaign,
  MdChat,
  MdChatBubbleOutline,
  MdClose,
  MdFavoriteBorder,
  MdGroup,
  MdGroups,
  MdLanguage,
  MdMail,
  MdMailOutline,
  MdOutlineCampaign,
  MdOutlineShoppingBag,
  MdPerson,
  MdPersonAdd,
  MdPersonOutline,
  MdSearch,
  MdShoppingBag,
  MdShoppingCart,
  MdTaskAlt,
} from "react-icons/md";

import "../styles/App.css";
import "../styles/Home.css";
import { useLocation, useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { isEmpty } from "../functions/isEmpty";
import { useLanguage } from "../contexts/LanguageContext";

export default function Footer({
  isMobile,
  user,
  cart,
  scrollToObject,
  language,
  setLanguage,
  texts,
}) {
  let navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="home_section" style={{ backgroundColor: "#f7f7f7" }}>
      <div className="home_section_footer">
        <div className="home_section_footer_top">
          <div className="home_section_footer_top_left">
            <img
              src="https://starthome.ai/starthome_logo_v2.png"
              className="home_section_footer_top_left_logo"
              onClick={() => navigate("/")}
            />
          </div>
          <div className="home_section_footer_top_right">
            <div className="home_section_footer_top_right_icon">
              <img
                src="/youtube_icon.png"
                className="home_section_footer_top_right_icon_img"
              />
            </div>
            <div className="home_section_footer_top_right_icon">
              <img
                src="/instagram_icon.png"
                className="home_section_footer_top_right_icon_img"
              />
            </div>
            <div className="home_section_footer_top_right_icon">
              <img
                src="/tiktok_icon.png"
                className="home_section_footer_top_right_icon_img"
              />
            </div>
            <div className="home_section_footer_top_right_icon">
              <img
                src="/facebook_icon.png"
                className="home_section_footer_top_right_icon_img"
              />
            </div>
          </div>
        </div>
        <div className="home_section_footer_bottom">
          <div className="home_section_footer_bottom_left">
            © 2025 Servist Software GmbH
          </div>
          <div className="home_section_footer_bottom_right">
            <div
              className="_home_section_footer_bottom_right_element"
              onClick={() => navigate("/imprint")}>
              {language == "Deutsch" ? texts.de.agb : texts.en.agb}
            </div>
            <div
              className="_home_section_footer_bottom_right_element"
              onClick={() => navigate("/imprint")}>
              {language == "Deutsch" ? texts.de.imprint : texts.en.imprint}{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const LanguageIcon = styled(MdLanguage)`
  font-size: 33px;
  color: #777777ff;
`;

const CartIcon = styled(MdOutlineShoppingBag)`
  font-size: 33px;
  color: #777777ff;
`;

const PersonIcon = styled(MdPersonAdd)`
  font-size: 33px;
  color: #717171;
`;

const PersonIconActive = styled(MdPersonAdd)`
  font-size: 33px;
  color: #950178;
`;

const GroupIcon = styled(MdGroups)`
  font-size: 36px;
  color: #717171;
`;

const GroupIconActive = styled(MdGroups)`
  font-size: 36px;
  color: #950178;
`;

const SearchIcon = styled(MdSearch)`
  font-size: 32px;
  color: #717171;
  margin-bottom: -2px;
`;

const SearchIconActive = styled(MdSearch)`
  font-size: 32px;
  color: #ff29a7;
  margin-bottom: -2px;
`;

const ChatsIcon = styled(MdChatBubbleOutline)`
  font-size: 26px;
  color: #717171;
`;

const ChatsIconActive = styled(MdChatBubbleOutline)`
  font-size: 26px;
  color: #2d81e0;
`;

const TasksIcon = styled(MdTaskAlt)`
  font-size: 26px;
  color: #717171;
`;

const TaskIconActive = styled(MdTaskAlt)`
  font-size: 26px;
  color: #2d81e0;
`;

const AutoIcon = styled(MdAutoAwesome)`
  font-size: 26px;
  color: #717171;
`;

const AutoIconActive = styled(MdAutoAwesome)`
  font-size: 26px;
  color: #2d81e0;
`;

const MailIcon = styled(MdMailOutline)`
  font-size: 31px;
  color: #717171;
  margin-bottom: -2px;
`;

const MailIconActive = styled(MdMail)`
  font-size: 31px;
  color: #ff29a7;
  margin-bottom: -2px;
`;

const BankIcon = styled(MdAccountBalance)`
  font-size: 27px;
  color: #717171;
  margin-bottom: -1px;
`;

const BankIconActive = styled(MdAccountBalance)`
  font-size: 27px;
  color: #ff29a7;
  margin-bottom: -1px;
`;

const CampaignIcon = styled(MdCampaign)`
  font-size: 32px;
  color: #717171;
  margin-bottom: -1px;
`;

const CampaingIconActive = styled(MdCampaign)`
  font-size: 32px;
  color: #ff29a7;
  margin-bottom: -1px;
`;

const CalendarIcon = styled(MdCalendarToday)`
  font-size: 25px;
  color: #717171;
  margin-bottom: 2px;
`;

const CalendarIconActive = styled(MdCalendarToday)`
  font-size: 25px;
  color: #ff29a7;
  margin-bottom: 2px;
`;
